export default {
  'pages.home': 'Home',
  'pages.about': 'About',
  'pages.login_form': 'Login Form',
  'pages.signup_success': 'Signup Success',
  'pages.create_business_profile': 'Create Business Profile',
  'pages.complete_profile': 'Complete Profile',
  'pages.send_password_successfully': 'Send Password Successfully',
  'pages.forget_password': 'Forget Password',
  'pages.ticket_mangment': 'Ticket Mangement',
};
